._CatalogueConfig_107jx_1 textarea.ant-input {
  resize: none;
  height: 80px;
}